import React from 'react';
import Button from '../Button/Button';
import LineText from '../LineText/LineText';
import './TextImageRow.scss';
import { FadeInOnScroll } from '../../Utilities/FadeInOnScroll';


const TextImageRow = ({ lineText, title, image, paragraph1, paragraph2, paragraph3, divClass, animate, rowReverse, buttonText, buttonUrl, children }) => {
    const [ref] = FadeInOnScroll();

    return (
        <section className={`row no-gutters text-image ${divClass != null ? divClass : ""}`}>
            <div className="container-xxl">
                <div ref={animate ? ref : null} className="container-ac">
                    <div className={`text-image-container no-gutters  ${rowReverse ? "row-reverse" : ""}`}>
                        <div className={`col-12 col-md-7 ${rowReverse ? "reverse" : "pr-0 pr-md-5"}`}>
                            <LineText lineText={lineText} />
                            <div className="text mb-4">
                                <h2>{title}</h2>
                                <div className="pt-2">
                                    <p>{paragraph1}</p>
                                    {paragraph2 && <p>{paragraph2}</p>}
                                    {paragraph3 && <p>{paragraph3}</p>}
                                </div>
                            </div>
                            {children}
                            {buttonText && buttonUrl &&
                                <div className="text-center text-md-left pt-3">
                                    <Button buttonText={buttonText} buttonUrl={buttonUrl} />
                                </div>
                            }
                        </div>
                        <div className={`col-12 col-md-5 text-center image`}>
                            <img src={image} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default TextImageRow;